import {TableLine} from '@dropbox/dig-icons/assets';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {TableCellNode, TableRowNode} from '@lexical/table';
import {$createParagraphNode, $getSelection} from 'lexical';
import {$createEnhancedTableNode} from 'plugins/enhancedTableCells';
import {useCallback} from 'react';

import {ToolbarButton} from './ToolbarButton';

export const TableToolbarButton = () => {
  const [editor] = useLexicalComposerContext();

  const handleInsertTable = useCallback(() => {
    editor.update(() => {
      const selection = $getSelection();
      if (selection) {
        // Create a simple 3x3 table using the existing transformer approach
        const tableNode = $createEnhancedTableNode();

        // Create rows and cells manually
        for (let i = 0; i < 2; i++) {
          const rowNode = new TableRowNode();

          // Apply header class to first row
          if (i === 0) {
            // rowNode.addClass('header-row');
          }

          for (let j = 0; j < 3; j++) {
            const cellNode = new TableCellNode();
            const paragraphNode = $createParagraphNode();

            cellNode.append(paragraphNode);
            rowNode.append(cellNode);
          }
          tableNode.append(rowNode);
        }

        // Insert the table at the current selection
        selection.insertNodes([tableNode]);
      }
    });
  }, [editor]);

  return (
    <ToolbarButton
      title="Insert table"
      onClick={handleInsertTable}
      icon={TableLine}
      keycaps={['Command', 'Shift', 'T']}
    />
  );
};
